/**
 * Service Registration
 * 
 * This file ensures all services are properly registered with the TSyringe DI container.
 * We explicitly resolve services to ensure they are registered, as @singleton() decorators
 * alone may not be sufficient if the class isn't instantiated elsewhere.
 */

import { container } from "tsyringe";
import { GlobalNotificationService } from "./global-notification.service";
import { IssueFormService } from "./issue-form.service";
import { IssueCommandBuilderService } from "./issue-command-builder.service";
import { IssueDialogRendererService } from "./issue-dialog-renderer.service";
import { TimelineLayoutService } from "./timeline-layout.service";
import { TimelineDragIntervalCalculator } from "./timeline-drag-interval-calculator.service";
import { TimelineRequestManager } from "./timeline-request-manager.service";
import { TimelineInvalidationService } from "./timeline-invalidation.service";
import { FakeIssueDataService } from "./fake-issue-data.service";
import { AuthHydrationService } from "./auth-hydration.service";
import { MyOrganizerNotificationService } from "./my-organizer-notification.service";
import { ImagePreviewListener } from "./image-preview.listener";
import { AxisDataClient } from "../connectivity/axis-data-client";

// Explicitly register services with the DI container
// This ensures they are available when components try to resolve them
container.resolve(GlobalNotificationService);
container.resolve(IssueFormService);
container.resolve(IssueCommandBuilderService);
container.resolve(IssueDialogRendererService);
container.resolve(TimelineLayoutService);
container.resolve(TimelineDragIntervalCalculator);
container.resolve(TimelineRequestManager);
container.resolve(TimelineInvalidationService);
container.resolve(FakeIssueDataService);
container.resolve(AuthHydrationService);
container.resolve(MyOrganizerNotificationService);
container.resolve(ImagePreviewListener);
container.resolve(AxisDataClient);

// Export services for convenient access
export * from "./global-notification.service";
export * from "./issue-form.service";
export * from "./issue-command-builder.service";
export * from "./issue-dialog-renderer.service";
export * from "./timeline-layout.service";
export * from "./timeline-drag-interval-calculator.service";
export * from "./timeline-request-manager.service";
export * from "./timeline-invalidation.service";
export * from "./fake-issue-data.service";
export * from "./auth-hydration.service";
export * from "./my-organizer-notification.service";
export * from "./image-preview.listener";
export * from "./backend-axis-data.service";
export { AxisDataClient } from "../connectivity/axis-data-client";